export enum GlobalSuggestionSwitchType {
  SemboRecommends = 'SemboRecommends',
  LowestPrice = 'LowestPrice',
}

export interface GlobalSuggestionSwitchOption {
  type: GlobalSuggestionSwitchType;
  text: string;
  price: string | undefined;
  isSelected: boolean;
}
